<ng-content select="[start]"></ng-content>
<ng-content select="[center]"></ng-content>
<ng-content select="[end]"></ng-content>
